import type {JSX} from 'react'

interface DisplayPetNamesProps {
	petResultsList: string[]
	moreThanFortyNames: boolean
	loadMore?: boolean
}

export const DisplayPetNames = ({
	petResultsList,
	moreThanFortyNames,
	loadMore,
}: DisplayPetNamesProps): JSX.Element => {
	const unfilteredNames = petResultsList
	const names = []

	if (!loadMore && moreThanFortyNames) {
		const shuffledNames = unfilteredNames
			.slice()
			.sort(() => 0.5 - Math.random())
		// Push first 40 names
		names.push(...shuffledNames.slice(0, 40).sort())
	} else {
		names.push(...unfilteredNames)
	}

	return (
		<ul className="columns-2 md:columns-4">
			{names.map((name) => (
				<li key={name}>{name}</li>
			))}
		</ul>
	)
}
